'use client';

import { identifyUser } from '@kcd/event-tracker';
import { useQuery } from 'react-query';

import { BUYER_QUERY_KEY } from '~/api/query-keys';

// ============================================================================
// Buyer Query Hooks
// ============================================================================

/**
 * 현재 사용자 정보 조회 훅
 */
// GET /api/market-place/v1/buyer
export const useBuyer = () => {
  const { queryKey, queryFn } = BUYER_QUERY_KEY.current();

  return useQuery(queryKey, queryFn, {
    suspense: true,
    keepPreviousData: true,
    onSuccess: (data) => {
      if (data) {
        identifyUser(data.trackingId as string, {
          name: data.name,
          publicUserId: data.uuid,
        });
      }
    },
  });
};

/**
 * 현재 사용자 정보 조회 훅 (non-suspense)
 *
 * TrackPage 처럼 Suspense 경계 밖에서 렌더되거나 user 가 optional 인
 * cross-cutting 컴포넌트에서 사용한다. (suspend 하지 않고 user 는 undefined 일 수 있음)
 */
// GET /api/market-place/v1/buyer
export const useBuyerNonSuspense = () => {
  const { queryKey, queryFn } = BUYER_QUERY_KEY.current();

  return useQuery(queryKey, queryFn, {
    suspense: false,
    keepPreviousData: true,
    onSuccess: (data) => {
      if (data) {
        identifyUser(data.trackingId as string, {
          name: data.name,
          publicUserId: data.uuid,
        });
      }
    },
  });
};

/**
 * 플러스 멤버십 정보 조회 훅
 */
// GET /api/market-place/v1/buyer/plus-membership
export const useBuyerPlusMembership = () => {
  const { queryKey, queryFn } = BUYER_QUERY_KEY.plusMembership();

  return useQuery(queryKey, queryFn, {
    suspense: true,
  });
};

/**
 * 마이페이지 정보 조회 훅
 */
// GET /api/market-place/v1/buyer/my-page
export const useBuyerMyPage = () => {
  const { queryKey, queryFn } = BUYER_QUERY_KEY.myPage();

  return useQuery(queryKey, queryFn, {
    suspense: true,
  });
};
